import React, { FC } from 'react'
import { Icon, IconProps } from '@chakra-ui/react'
import { defineDirection, Direction } from './definitions'

type ArrowProps = IconProps & {
  direction?: Direction
}

const Arrow: FC<ArrowProps> = ({ direction = Direction.Right, ...chakraProps }) => (
  <Icon
    transform={defineDirection(direction)}
    viewBox="0 0 16 16"
    // ChakraUIs type definitions clash apparently.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {...(chakraProps as any)}>
    <path
      d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z"
      fill="currentColor"
    />
  </Icon>
)

// eslint-disable-next-line functional/immutable-data
Arrow.displayName = 'Arrow'

export { Arrow }
